// ResumableGuardian.js
import { connect } from 'react-redux';
import getResumableMessageData from '../selector/getResumableMessageData.js';
import ResumableGuardian from '../component/ResumableGuardian.jsx';

function mapStateToProps(state) {
  return {
    resumableMessageItemIds: getResumableMessageData(state, 'itemIds'),
  };
}

export default connect(mapStateToProps)(ResumableGuardian);
